import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-dark-300' : 'text-dark-500';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="relative">
        <div className="w-11 h-11 rounded-full bg-athletic-500 flex items-center justify-center transition-transform group-hover:scale-105 shadow-button">
          <span className="font-display font-semibold text-white text-lg leading-none tracking-tight">PC</span>
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-semibold text-xl tracking-tight ${textColor} transition-colors`}>
          Pitch <span className="text-athletic-600">Craft</span>
        </span>
        <span className={`text-[10px] font-medium uppercase tracking-[0.3em] mt-1 ${subTextColor} transition-colors`}>
          Gear &middot; Musical Instruments
        </span>
      </div>
    </Link>
  );
};

export default Logo;
